import { render, staticRenderFns } from "./SdksInstructions.vue?vue&type=template&id=71bb3eab&scoped=true"
import script from "./SdksInstructions.vue?vue&type=script&lang=js"
export * from "./SdksInstructions.vue?vue&type=script&lang=js"
import style0 from "./SdksInstructions.vue?vue&type=style&index=0&id=71bb3eab&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb3eab",
  null
  
)

export default component.exports